module.exports = __webpack_public_path__ + "img/GOLFOURIT1200x628-2.4a3192dc.png";